export default "__VITE_ASSET__dc2dd950__"